export const propInfo = {
  name: {
    saveSuccess: "Name der Unterkunft erfolgreich gespeichert",
    successTitle: "Erfolg",
    saveError: "Der Name der Unterkunft konnte nicht gespeichert werden",
  },
  capacity: {
    saveSuccess: "Kapazität erfolgreich gespeichert",
    saveError: "Die Kapazität konnte nicht gespeichert werden",
  },
  location: {
    loadError: "Die Daten des Inserats konnten nicht geladen werden.",
    appliedBulk: "Standort auf {count} verknüpfte Unterkünfte angewendet",
    saveSuccess: "Standort erfolgreich gespeichert",
    partialError: "Einige Unterkünfte konnten nicht aktualisiert werden",
    savePropertySuccess: "Standort der Unterkunft erfolgreich gespeichert",
    saveError: "Der Standort der Unterkunft konnte nicht gespeichert werden",
    loading: "Standort des Inserats wird geladen…",
    noUnitsTitle: "Für dieses Inserat sind noch keine Einheiten eingerichtet.",
    noUnitsText: "Legen Sie mindestens eine Einheit an, um den Standort einzurichten.",
    bulkNotice: "Diese Änderung gilt für die {count} Unterkünfte, die mit {name} verknüpft sind.",
  },
  description: {
    saveSuccess: "Beschreibung erfolgreich gespeichert",
    saveError: "Die Beschreibung konnte nicht gespeichert werden",
    cloneTitleNoun: "Beschreibung",
    cloneItemNoun: "die Beschreibung",
  },
};
